
export { TransformObjectModule } from './lib/transform-object.module';
export { TransformObjectPipe } from './lib/transform-object.pipe';
export { TransformObjectsPipe } from './lib/transform-objects.pipe';
export { TransformObjectService } from './lib/transform-object.service';
